export const getFileExtension = (file: File | Blob): string => {
  if ('name' in file) {
    return file.name.split('.').pop() || '';
  }
  return file.type.replace(/(.*)\//g, '');
};

export const getFileNameFromUrl = (url: string): string => {
  if (!url) return url;
  return url.split('/').pop() || '';
};

// eslint-disable-next-line require-await
export async function detectFileType(file: File | Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      if (!reader.result) {
        return reject('Failed to read file');
      }

      const uint = new Uint8Array(reader.result as ArrayBuffer);
      const header = uint
        .subarray(0, 8)
        .reduce((acc, byte) => acc + byte.toString(16).padStart(2, '0'), '');
      let fileType: string;

      switch (true) {
        case header.startsWith('ffd8ffe0') ||
          header.startsWith('ffd8ffe1') ||
          header.startsWith('ffd8ffe2'):
          fileType = FILE_EXTENSION_TO_MIME_TYPE.jpeg;
          break;
        case header.startsWith('89504e47'):
          fileType = FILE_EXTENSION_TO_MIME_TYPE.png;
          break;
        case header.startsWith('47494638'):
          fileType = FILE_EXTENSION_TO_MIME_TYPE.gif;
          break;
        case header.startsWith('25504446'):
          fileType = FILE_EXTENSION_TO_MIME_TYPE.pdf;
          break;
        case header.startsWith('504b0304') ||
          header.startsWith('504b0506') ||
          header.startsWith('504b0508'):
          fileType = FILE_EXTENSION_TO_MIME_TYPE.docx;
          break;
        case header.startsWith('d0cf11e0'):
          fileType = FILE_EXTENSION_TO_MIME_TYPE.doc;
          break;
        case header.startsWith('52617221'):
          fileType = FILE_EXTENSION_TO_MIME_TYPE.txt;
          break;
        default:
          fileType = 'unknown';
          break;
      }

      resolve(fileType);
    };

    reader.onerror = () => reject('Error reading file');
    reader.readAsArrayBuffer(file.slice(0, 8));
  });
}

export const FILE_EXTENSIONS = {
  pdf: 'pdf',
  doc: 'doc',
  docx: 'docx',
  txt: 'txt',
  jpg: 'jpg',
  jpeg: 'jpeg',
  png: 'png',
  gif: 'gif',
} as const;

export const FILE_EXTENSION_TO_MIME_TYPE = {
  [FILE_EXTENSIONS.pdf]: 'application/pdf',
  [FILE_EXTENSIONS.doc]: 'application/msword',
  [FILE_EXTENSIONS.docx]:
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  [FILE_EXTENSIONS.txt]: 'text/plain',
  [FILE_EXTENSIONS.jpg]: 'image/jpeg',
  [FILE_EXTENSIONS.jpeg]: 'image/jpeg',
  [FILE_EXTENSIONS.png]: 'image/png',
  [FILE_EXTENSIONS.gif]: 'image/gif',
} as const;

export const DEFAULT_IMAGE_FILE_EXTENSIONS = [
  FILE_EXTENSIONS.jpeg,
  FILE_EXTENSIONS.jpg,
  FILE_EXTENSIONS.png,
];
